import React from 'react'
import { useIPOrganismosContext } from '../../contexts'
import { GridForm } from '../../../ip/components/form/grid-form.component'

export const IPOrganismosForm = () => {
  const { inputsConfig, formConfig } = useIPOrganismosContext()

  return (
    <form>
      <GridForm {...{ grid: formConfig, inputs: inputsConfig() }} />
    </form>
  )
}
